/*=========================================================================================
  File Name: module-resource.js
  Description: Resource Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-resource-state';
import mutations from './module-resource-mutations';
import actions from './module-resource-actions';
import getters from './module-resource-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
